module.exports = __webpack_public_path__ + "static/media/plusIcon.7d7e41a1.svg";